import React, { useState, useEffect } from 'react';
import { Badge, Menu, Dropdown, Descriptions, Tabs, Tag, Space, DatePicker, Search, Card, Radio, Form, notification, message, Row, Modal, Upload, Col, Input, Image, Select, Divider, Table, Button } from 'antd';
import { SearchOutlined, PlusOutlined, DeleteOutlined, EditOutlined, SaveOutlined, FileAddOutlined, UploadOutlined, LoadingOutlined, SyncOutlined, } from '@ant-design/icons';
//import { useNavigate, useParams } from 'react-router-dom';
// import Swal from 'sweetalert2';
import { fetchData, sendData, sendDataPut } from '../../httpRequests';
import Item from 'antd/lib/list/Item';
import { async } from '@firebase/util';
import moment from 'moment';
import { ExportExcel } from '../../components/ExportExcel/ExportExcel';
import { DownOutlined } from '@ant-design/icons';


const Billing = () => {
    const [filteredOrders, setFilteredOrders] = useState([]);
    const [filterBilling, setfilterBilling] = useState([])
    const [orders, setOrders] = useState([]);
    const [pharmacies, setpharmacies] = useState([])
    const [billing, setbilling] = useState([])
    const url = '/orders/getOrders';
    const urlOderState = '/orders/getStates';
    const urlPharmacies = '/Pharmacies/getPharmacies'
    //const urlBilling = '/bill/getBilling'
    const urlCreateBilling = '/bill/createBillingHeader'
    const urlBillingDetail = '/bill/getBillingDetailByPharmacy';
    const urlBillingStatus = '/bill/getBillingstatus'
    const urlBillingBypharmacy = '/bill/getBillingHeaderByPharmacyId'
    const [orderStatesDelivered, setorderStatesDelivered] = useState(0);
    const [orderStatesPickedUpByClient, setorderStatesPickedUpByClient] = useState(0);
    const [billingStatusPending, setbillingStatusPending] = useState(0);
    const [billingStatusPaid, setbillingStatusPaid] = useState(0);
    const [initialFilterDate, setinitialFilterDate] = useState(null)
    const [finalFilterDate, setfinalFilterDate] = useState(null)
    const [ordersIdToBeAdded, setordersIdToBeAdded] = useState([])
    const [SelectedOrders, setSelectedOrders] = useState([])
    const [showModal, setshowModal] = useState(false)
    const [showDetailModal, setshowDetailModal] = useState(false)
    const [showProductModal, setshowProductModal] = useState(false)
    const [fetchingDetails, setfetchingDetails] = useState(false)
    const [form] = Form.useForm();
    const [billingFormValues, setbillingFormValues] = useState({})
    const [billingDetail, setbillingDetail] = useState([])
    const [billingDetailOrder, setbillingDetailOrder] = useState([])
    const [billingOrderDetail, setbillingOrderDetail] = useState([])
    const [Productsdata, setProductsdata] = useState([])
    const [productDetail, setproductDetail] = useState({})
    const [subTotal, setsubTotal] = useState(0)
    const [selectionType, setSelectionType] = useState('checkbox');
    const [lastBillingSubmited, setlastBillingSubmited] = useState([])
    const [PHARMACY_LOGGED, setPHARMACY_LOGGED] = useState(localStorage.getItem("PHARMACY_LOGGED"))

    const { TabPane } = Tabs;
    const { Option } = Select;
    const { RangePicker } = DatePicker;


    const getBillingDetailByPharmacy = (billing_id) => {
        //console.log(PHARMACY_LOGGED)
        const data = {
            billing_id,
            pharmacy_id: PHARMACY_LOGGED

        }
        sendData(urlBillingDetail, data).then((response) => {
            //console.log(response)
            const billingDetail = response['billingDetail']
            let billingDetailOrders;
            if (billingDetail.length > 0) {
                billingDetailOrders = billingDetail.map((b) => {
                    // console.log(...b.order)


                    return {

                        id: b.id,
                        billing_id: b.billing_id,
                        biillingDeleted: b.deleted,
                        billingCreated_at: b.created_at,
                        billingUpdate_at: b.updated_at,

                        ...b.Order

                    }

                })
            }
            const varAux = billingDetail.map((bdo) => {
                return {
                    id: bdo.id,
                    billing_id: bdo.billing_id,
                    biillingDeleted: bdo.deleted,
                    billingCreated_at: bdo.created_at,
                    billingUpdate_at: bdo.updated_at,

                    Order: {
                        OrdersDetail: bdo.Order['OrdersDetail'].map((od) => {
                            return {
                                ProductOrderInformation: {
                                    ...od.PharmacyProduct.Products,
                                    active: od.PharmacyProduct.active,
                                    apply_taxes: od.PharmacyProduct.apply_taxes,
                                    code_bar: od.PharmacyProduct.code_bar,
                                    created_at: od.PharmacyProduct.created_at,
                                    created_by: od.PharmacyProduct.created_by,
                                    gift_price: od.PharmacyProduct.gift_price,
                                    gift_status: od.PharmacyProduct.gift_status,
                                    Pharmacy_Product_id: od.PharmacyProduct.id,
                                    ivu_municipal: od.PharmacyProduct.ivu_municipal,
                                    ivu_statal: od.PharmacyProduct.ivu_statal,
                                    pharmacy_id: od.PharmacyProduct.pharmacy_id,
                                    price: od.PharmacyProduct.price,
                                    product_id: od.PharmacyProduct.product_id,
                                    stock: od.PharmacyProduct.stock,
                                    updated_at: od.PharmacyProduct.updated_at,
                                    updated_by: od.PharmacyProduct.updated_by,

                                },
                                claim_register: od.claim_register,
                                created_at: od.created_at,
                                delivered_date: od.delivered_date,
                                from: od.from,
                                gift_price: od.gift_price,
                                gift_status_id: od.gift_status_id,
                                Order_detail_id: od.id,
                                ivu_municipal: od.ivu_municipal,
                                ivu_statal: od.ivu_statal,
                                message: od.message,
                                order_id: od.order_id,
                                original_price: od.original_price,
                                pharmacy_product_id: od.pharmacy_product_id,
                                product_order_status_id: od.product_order_status_id,
                                product_price: od.product_price,
                                quantity: od.quantity,
                                stimated_delivered_date: od.stimated_delivered_date,
                                taxes: od.taxes,
                                total_balance: od.total_balance,
                                total_product: od.total_product,
                                updated_at: od.updated_at,
                                validated: od.validated

                            }
                        }),
                        address_1: bdo.Order.address_1,
                        address_2: bdo.Order.address_2,
                        alias: bdo.Order.alias,
                        city: bdo.Order.city,
                        client_state: bdo.Order.client_state,
                        code: bdo.Order.code,
                        created_at: bdo.Order.created_at,
                        created_by: bdo.Order.created_by,
                        description_order: bdo.Order.description_order,
                        device: bdo.Order.device,
                        driver_id: bdo.Order.driver_id,
                        first_transaction: bdo.Order.first_transaction,
                        hasBilling: bdo.Order.hasBilling,
                        Order_id: bdo.Order.id,
                        last_card_digit: bdo.Order.last_card_digit,
                        latitude: bdo.Order.latitude,
                        longitude: bdo.Order.longitude,
                        notes: bdo.Order.notes,
                        order_state_id: bdo.Order.order_state_id,
                        pharmacy_id: bdo.Order.pharmacy_id,
                        phone: bdo.Order.phone,
                        pick_up_status: bdo.Order.pick_up_status,
                        stripe_card_id: bdo.Order.stripe_card_id,
                        stripe_charged_id: bdo.Order.stripe_charged_id,
                        total_order: bdo.Order.total_order,
                        updated_at: bdo.Order.updated_at,
                        user_id: bdo.Order.user_id,
                        zip_Code: bdo.Order.zip_Code,
                        deposit_amount: bdo.Order.deposit_amount,
                        clientBankFee: bdo.Order.clientBankFee
                        // total_to_deposit:1
                    }
                }
            })

            //console.log(varAux, "order2")
            setbillingOrderDetail(varAux.filter((bd) => {
                return bd.Order.pharmacy_id == PHARMACY_LOGGED
                // return{
                //     ...bd.Order,
                //     billing_id: bd.billing_id,
                //     created_at:bd.created_at,
                //     deleted:bd.deleted,
                //     id:bd.id,
                //     order_id:bd.order_id,
                //     updated_at:bd.updated_at,
                // } 
            }))
            setbillingDetailOrder(billingDetailOrders)
            console.log("detail", varAux.filter((bd) => {
                return bd.Order.pharmacy_id == PHARMACY_LOGGED
                // return{
                //     ...bd.Order,
                //     billing_id: bd.billing_id,
                //     created_at:bd.created_at,
                //     deleted:bd.deleted,
                //     id:bd.id,
                //     order_id:bd.order_id,
                //     updated_at:bd.updated_at,
                // } 
            }))
        })
    }
    const getOrder = () => {
        fetchData(url).then(async (response) => {
            if (Object.keys(response).length > 0) {
                //console.log(orderStatesDelivered, 'valor')
               // const Orders = await response['orders'];
               const Orders = await response['orders'].map((o) => {
                return {
                    ...o, totalDeliveryFee: o.driver_zip_code === 'admin' || o.ronpon_id !== 'Not specified' ? 0.00 : o.totalDeliveryFee,
                    deliveryBy:o.totalDeliveryFee===0?'Picked up' :o.ronpon_id !== 'Not specified'?'Ronpon':o.driver_zip_code === 'admin'?'Facilito':'Farmacy'
                }
            });
                //console.log(response, "comment2")
                setOrders(Orders.filter((x) => { return (x.order_state_id == orderStatesDelivered || x.order_state_id == orderStatesPickedUpByClient) && x.pharmacy_id == PHARMACY_LOGGED }));
                console.log(Orders)
                setFilteredOrders(Orders.filter((x) => {
                    return (x.order_state_id == orderStatesDelivered || x.order_state_id == orderStatesPickedUpByClient) && x.pharmacy_id == PHARMACY_LOGGED
                }).reverse());
            }
        });
    }
    const getBillingstatus = () => {
        fetchData(urlBillingStatus).then(async (response) => {
            if (Object.keys(response).length > 0) {
                const billingStatus = response['billingStatus'];
                let id;
                for (let i in billingStatus) {
                    if (billingStatus[i].code == 'PENDING') {//normalmente no hardcodeo, pero si alguno ve esto despues de mi, que sepa que habia mucha presion por hacer las cosas rapido
                        id = billingStatus[i].id
                        // console.log(id)
                        if (id != undefined) {
                            setbillingStatusPending(id)
                        }
                    }
                    if (billingStatus[i].code == 'PAID') {//normalmente no hardcodeo, pero si alguno ve esto despues de mi que sepa que habia mucha presion por hacer las cosas rapido
                        id = billingStatus[i].id
                        // console.log(id)
                        if (id != undefined) {
                            setbillingStatusPaid(id)
                        }
                    }

                    //console.log(orderStates[i].name)

                }
            }
        })
    }
    const getOrderStates = () => {
        fetchData(urlOderState).then(async (response) => {
            if (Object.keys(response).length > 0) {
                const orderStates = response['orderStates'];
                let id;
                for (let i in orderStates) {
                    if (orderStates[i].name == 'Delivered') {//normalmente no hardcodeo, pero si alguno ve esto despues de mi que sepa que habia mucha presion por hacer las cosas rapido
                        id = orderStates[i].id
                        // console.log(id)
                        if (id != undefined) {
                            setorderStatesDelivered(id)
                        }

                    }
                    if (orderStates[i].name == 'Pickup by User') {//normalmente no hardcodeo, pero si alguno ve esto despues de mi que sepa que habia mucha presion por hacer las cosas rapido
                        id = orderStates[i].id
                        // console.log(id)
                        if (id != undefined) {
                            setorderStatesPickedUpByClient(id)
                        }

                    }

                    //console.log(orderStates[i].name)

                }
                //console.log(id)
                // if (orderStatesDelivered) {
                //     console.log(orderStatesDelivered, "comment")

                // }
                // console.log(orderStatesDelivered)
            }
        });
    }

    const getPharmacies = () => {
        fetchData(urlPharmacies).then((response) => {
            if (Object.keys(response).length > 0) {
                const pharmacies = response['pharmacy'];
                setpharmacies(pharmacies);
            }
        });
    }
    const getBilling = () => {
        const data = { pharmacy_id: PHARMACY_LOGGED }
        sendData(urlBillingBypharmacy, data).then((response) => {
            if (Object.keys(response).length > 0) {
                console.log("Billings por farmacia", response)
                const billing = response['billing'].map((bp) => {
                    //console.log(bp['BillingDetail'])
                    // let belongToCurrentPharmacy =false

                    // const BD= bp['BillingDetail'].filter(bd=>{
                    //  //   console.log("orders",bd.Order.pharmacy_id)
                    //  return bd.Order.pharmacy_id===PHARMACY_LOGGED

                    // })
                    // if(belongToCurrentPharmacy){
                    //     return{
                    //         ...bp
                    //     }
                    // }
                    // console.log("Billing detail",BD)
                    return {
                        BillingDetail: bp['BillingDetail']
                        // .filter((bd) => {
                        //    return bd.Order.pharmacy_id==PHARMACY_LOGGED
                        //     // return{
                        //     //     ...bd.Order,
                        //     //     billing_id: bd.billing_id,
                        //     //     created_at:bd.created_at,
                        //     //     deleted:bd.deleted,
                        //     //     id:bd.id,
                        //     //     order_id:bd.order_id,
                        //     //     updated_at:bd.updated_at,
                        //     // } 
                        // })
                        ,

                        amount_orders: bp['BillingDetail'].length,
                        billing_status_id: bp.billing_status_id,
                        code: bp.code,
                        created_at: bp.created_at,
                        created_by: bp.created_by,
                        deleted: bp.deleted,
                        description_billing: bp.description_billing,
                        id: bp.id,
                        stimated_paid_date: bp.stimated_paid_date,
                        total_billing: bp['BillingDetail'].reduce((accumulator, current) => accumulator + current.Order.total_order, 0),
                        updated_at: bp.updated_at,
                        updated_by: bp.updated_by,
                        totalTransactioFee: bp['BillingDetail'].reduce((accumulator, current) => accumulator + current.Order.totalTransactioFee, 0),
                        totalDeliveryFee: bp['BillingDetail'].reduce((accumulator, current) => accumulator + current.Order.totalDeliveryFee > 0 ? current.totalDeliveryFee - 1 + ((current.totalDeliveryFee - 1) * 0.04) : 0.00, 0),
                        clientBankFee: bp['BillingDetail'].reduce((accumulator, current) => accumulator + ((current.Order.deposit_amount * 0.03) + 0.23) + (((((current.Order.deposit_amount * 0.03) + 0.23) * 0.04).toFixed(2)) * 1) + (current.Order.clientBankFee + ((current.Order.clientBankFee) * 0.115)).toFixed(2) * 1, 0),
                        deposit_amount: bp['BillingDetail'].reduce((accumulator, current) => accumulator + current.Order.deposit_amount, 0),
                        product_municipal_tax: bp['BillingDetail'].reduce((accumulator, current) => accumulator + current.Order.product_municipal_tax, 0),
                        product_state_tax: bp['BillingDetail'].reduce((accumulator, current) => accumulator + current.Order.product_state_tax, 0),
                        order_total_without_tax: bp['BillingDetail'].reduce((accumulator, current) => accumulator + current.Order.order_total_without_tax, 0),
                        total_to_deposit: bp['BillingDetail'].reduce((accumulator, current) => accumulator + (current.Order.deposit_amount - (((current.Order.deposit_amount * 0.03) + 0.23) + (((((current.Order.deposit_amount * 0.03) + 0.23) * 0.04).toFixed(2)) * 1) + (current.Order.clientBankFee + ((current.Order.clientBankFee) * 0.115)).toFixed(2) * 1)), 0)

                    }
                }
                );
                /* -product_municipal_tax
                 order_total_without_tax
                deposit_amount
                pharmacyBankFee
                deposit_amount_client
                totalDeliveryFee */
                const currentPharmacyBilling = billing//.filter(b=>{
                // return b['BillingDetail'].length>0
                // })
                setbilling(currentPharmacyBilling);
                setfilterBilling(currentPharmacyBilling)
                // console.log("billlin1",billing)
                // console.log("billing2", currentPharmacyBilling)//.map(x=>x['BillingDetail'].reduce((accumulator, current) => accumulator + current.Order.total_order, 0)))
            }
        });
    }

    const cropDate = (dateStr) => {
        const date = new Date(dateStr);
        if (dateStr) {
            return <span>{date.toLocaleDateString()}</span>;
        }
        else {
            return <span>Not Specified</span>;
        }
    };

    const columns = [
        { title: 'Order #', dataIndex: 'code', key: 'code' },
        // {
        //     title: 'Status',
        //     render: ({ order_state_id }) => (
        //         <span>
        //             {(order_state_id == 1 && 'Pending') ||
        //                 (order_state_id == 2 && 'Processing') ||
        //                 (order_state_id == 3 && 'Ready for pick up') ||
        //                 (order_state_id == 4 && 'On the way') ||
        //                 (order_state_id == 5 && 'Delivered') ||
        //                 (order_state_id == 6 && 'Rejected') ||
        //                 (order_state_id == 7 && 'Picked up by client')}
        //         </span>
        //     ),
        //     key: 'order_state_id'
        // },
        // {
        //     title: 'For Pickup',
        //     render: ({ pick_up_status }) => <span>{(pick_up_status == 1 && 'Yes') || 'No'}</span>
        // },
        {
            title: 'Date',
            render: ({ created_at }) => cropDate(created_at),
            key: 'created_at',
            defaultSortOrder: 'descend',
            sorter: {
                compare: (a, b) => new Date(a.created_at) - new Date(b.created_at),
                multiple: 1
            }
        },
        // {
        //     title: 'Time passed',
        //     render: ({ created_at }) => {
        //         const date = new Date(created_at);
        //         const today = new Date();
        //         let msec = today - date;
        //         let time = '';

        //         const dd = Math.floor(msec / 1000 / 60 / 60 / 24);
        //         msec -= dd * 1000 * 60 * 60 * 24;
        //         const hh = Math.floor(msec / 1000 / 60 / 60);
        //         msec -= hh * 1000 * 60 * 60;
        //         const mm = Math.floor(msec / 1000 / 60);
        //         msec -= mm * 1000 * 60;

        //         time = mm + 'min';

        //         if (hh > 0) {
        //             time = hh + 'hr ' + mm + 'min';
        //         }
        //         if (dd > 0) {
        //             time = dd + 'd ' + hh + 'hr ' + mm + 'min';
        //         }

        //         return <span>{time}</span>;
        //     },
        //     key: 'created_at',
        //     defaultSortOrder: 'ascend',
        //     sorter: {
        //         compare: (a, b) => new Date(a.created_at) < new Date(b.created_at),
        //         multiple: 1
        //     }
        // }
        {
            title: 'Sub Total $',
            render: ({ order_total_without_tax }) => (
                <div>
                    <span>{formatter.format(order_total_without_tax)}</span>
                </div>
            ),
            key: 'order_total_without_tax'
        },
        // {
        //     title: 'State Tax $',
        //     render: ({ product_state_tax }) => (
        //         <div>
        //             <span>{formatter.format(product_state_tax)}</span>
        //         </div>
        //     ),
        //     key: 'product_state_tax'
        // },
        {
            title: 'Municipal Tax $',
            render: ({ product_municipal_tax }) => (
                <div>
                    <span>{formatter.format(product_municipal_tax)}</span>
                </div>
            ),
            key: 'product_municipal_tax'
        },
        // {
        //     title: 'Total $',
        //     render: ({ total_order }) => (
        //         <div>
        //             <span>{formatter.format(total_order)}</span>
        //         </div>
        //     ),
        //     key: 'total_order'
        // },
        {
            title: 'Delivery by',
            render: ({ deliveryBy }) => (
                <div>
                    <span>{
                        deliveryBy
                    //formatter.format(totalDeliveryFee > 0 ? totalDeliveryFee - 1 + ((totalDeliveryFee - 1) * 0.04) : 0.00)
                    }</span>
                </div>
            ), key: 'totalDeliveryFee'
        },
        // {
        //     title: 'Delivery municipal tax',
        //     render: ({ totalDeliveryFee }) => (
        //         <div>
        //             <span>{formatter.format((totalDeliveryFee-1)*0.04)}</span>
        //         </div>
        //     ), key: 'delivery_fee_municipal_tax'
        // },
        // {
        //     title: 'Transaction fee',
        //     render: ({ totalTransactioFee }) => (
        //         <div>
        //             <span>{formatter.format(totalTransactioFee)}</span>
        //         </div>
        //     ), key: 'totalTransactioFee'
        // },
        {
            title: 'sub-total to deposit $',
            render: ({ deposit_amount }) => (
                <div>
                    <span>{formatter.format(deposit_amount)}</span>
                </div>
            ),
            key: 'deposit_amount'
        },
        {
            title: 'Processing fee  $',
            render: ({ deposit_amount, total_order, clientBankFee }) => (
                <div>
                    <span>{formatter.format(((deposit_amount * 0.03) + 0.23) + (((((deposit_amount * 0.03) + 0.23) * 0.04).toFixed(2)) * 1) + (clientBankFee + ((clientBankFee) * 0.115)).toFixed(2) * 1)}</span>
                </div>
            ),
            key: 'deposit_amount'
        },
        {
            title: 'total to deposit $',
            render: ({ deposit_amount, total_order, clientBankFee }) => (
                <div>
                    <span>{formatter.format(deposit_amount - (((deposit_amount * 0.03) + 0.23) + (((((deposit_amount * 0.03) + 0.23) * 0.04).toFixed(2)) * 1) + (clientBankFee + ((clientBankFee) * 0.115)).toFixed(2) * 1))
                        //((((deposit_amount*0.03)+0.23)+Math.round(((deposit_amount*0.03)+0.23)*0.04))+ (((total_order*0.03)+0.23)+((total_order*0.03)+0.23)*0.115)))
                    }</span>
                </div>
            ),
            key: 'deposit_amount'
        },
        // {
        //     title: 'Taxes',
        //     render: ({ deposit_amount }) => (
        //         <div>
        //             <span>{formatter.format(deposit_amount * 0.115)}</span>
        //         </div>
        //     ),
        //     key: 'total_order'
        // },
        {
            title: 'Status',
            render: ({ billing_status_id }) => (
                <Tag color={billing_status_id == 1 ? 'volcano' :
                    billing_status_id == 2 ? 'green' : 'orange'}>
                    {(billing_status_id == 1 && 'Pending') ||
                        (billing_status_id == 2 && 'Paid') || (billing_status_id == undefined && 'In transit')}
                </Tag>
            ),
            key: 'billing_status_id'
        },
        // { title: 'Pharmacy', dataIndex: 'name' },
        {
            title: 'Date',
            render: ({ stimated_paid_date }) => cropDate(stimated_paid_date),
            key: 'created_at',
            defaultSortOrder: 'ascend',
            //sortDirections: ['descend'],
            sorter: {
                compare: (a, b) => new Date(a.stimated_paid_date) > new Date(b.stimated_paid_date),
                // multiple: 1
            }
        },
        { title: 'Billing Code', render: ({ billingCode }) => billingCode ? billingCode : '-', key: 'billingCode' },
    ];

    const billingColumn = [
        { title: 'Code', dataIndex: 'code', key: 'code', fixed: 'left', },

        {
            title: 'Amount orders ', render: ({ amount_orders }) => (
                <span>{amount_orders}</span>
            ), key: 'code'
        },

        {
            title: 'Stimated pay date',
            render: ({ stimated_paid_date }) => cropDate(stimated_paid_date),
            key: 'stimated_paid_date',
            //defaultSortOrder: 'descend',
            sorter: {
                compare: (a, b) => new Date(a.stimated_paid_date) - new Date(b.stimated_paid_date),
                multiple: 1
            }
        },
        {
            title: 'Date',
            render: ({ created_at }) => cropDate(created_at),
            key: 'created_at',
            defaultSortOrder: 'descend',
            sorter: {
                compare: (a, b) => new Date(a.created_at) - new Date(b.created_at),
                multiple: 1
            },

        },
        { title: 'Description', dataIndex: 'description_billing' },
        {
            title: 'Status',
            render: ({ billing_status_id }) => (
                <Tag color={billing_status_id == 1 ? 'volcano' : 'green'}>
                    {(billing_status_id == 1 && 'Pending') ||
                        (billing_status_id == 2 && 'Paid') ||
                        (billing_status_id == 3 && 'Ready for pick up') ||
                        (billing_status_id == 4 && 'On the way') ||
                        (billing_status_id == 5 && 'Delivered') ||
                        (billing_status_id == 6 && 'Rejected') ||
                        (billing_status_id == 7 && 'Ready to be picked up by client')}
                </Tag>
            ),
            key: 'billing_status_id',
            defaultSortOrder: 'ascend',
            sorter: {
                compare: (a, b) => a.billing_status_id - b.billing_status_id,
                //multiple: 1
            }
        },
        {
            title: "Sub total",
            render: ({ order_total_without_tax }) => (
                <div>
                    <span>{formatter.format(order_total_without_tax)}</span>
                </div>
            )
        },
        {
            title: "Municipal Tax",
            render: ({ product_municipal_tax }) => (
                <div>
                    <span>{formatter.format(product_municipal_tax)}</span>
                </div>
            )
        },
        // {
        //     title: "State Tax",
        //     render: ({ product_state_tax }) => (
        //         <div>
        //             <span>{formatter.format(product_state_tax)}</span>
        //         </div>
        //     )
        // },

        // {
        //     title: "Transaction fee",
        //     render: ({ totalTransactioFee }) => (
        //         <div>
        //             <span>{formatter.format(totalTransactioFee)}</span>
        //         </div>
        //     )
        // },
        // {
        //     title: "Delivery by",
        //     render: ({ deliveryBy }) => (
        //         <div>
        //             <span>{
        //                 deliveryBy
        //             //formatter.format(totalDeliveryFee > 0 ? totalDeliveryFee + ((totalDeliveryFee) * 0.04) : 0.00)
        //             }</span>
        //         </div>
        //     )
        // },
        {

            title: "Sub total to deposit",
            render: ({ deposit_amount }) => (
                <div>
                    <span>{formatter.format(deposit_amount)}</span>
                </div>
            )
        },
        {
            title: "Processing fee",
            render: ({ clientBankFee }) => (

                <div>
                    <span> {formatter.format(clientBankFee)}</span>
                </div>
            ),
            fixed: 'right',
        },
        {

            title: "Total to deposit",
            render: ({ total_to_deposit }) => (
                <div>
                    <span>{formatter.format(total_to_deposit)}</span>
                </div>
            ),
            fixed: 'right',
        },
        // {
        //     title: "Taxes",
        //     render: ({ total_billing }) => (
        //         <div>
        //             <span>{formatter.format(total_billing * 0.115)}</span>
        //         </div>
        //     )
        // },

    ]
    const OrderColumns = [
        { title: 'Order #', dataIndex: 'code', key: 'code' },
        // { title: 'pharmacy_id #', dataIndex: 'pharmacy_id', key: 'pharmacy_id' },
        // {
        //     title: 'Status',
        //     render: ({ order_state_id }) => (
        //         <span>
        //             {(order_state_id == 1 && 'Pending') ||
        //                 (order_state_id == 2 && 'Processing') ||
        //                 (order_state_id == 3 && 'Ready for pick up') ||
        //                 (order_state_id == 4 && 'On the way') ||
        //                 (order_state_id == 5 && 'Delivered') ||
        //                 (order_state_id == 6 && 'Rejected') ||
        //                 (order_state_id == 7 && 'Ready to be picked up by client')}
        //         </span>
        //     ),
        //     key: 'order_state_id'
        // },
        // {
        //     title: 'For Pickup',
        //     render: ({ pick_up_status }) => <span>{(pick_up_status == 1 && 'Yes') || 'No'}</span>
        // },
        {
            title: 'Date',
            render: ({ created_at }) => cropDate(created_at),
            key: 'created_at',
            defaultSortOrder: 'descend',
            sorter: {
                compare: (a, b) => new Date(a.created_at) > new Date(b.created_at),
                multiple: 1
            }
        },
        // {
        //     title: 'Time passed',
        //     render: ({ created_at }) => {
        //         const date = new Date(created_at);
        //         const today = new Date();
        //         let msec = today - date;
        //         let time = '';

        //         const dd = Math.floor(msec / 1000 / 60 / 60 / 24);
        //         msec -= dd * 1000 * 60 * 60 * 24;
        //         const hh = Math.floor(msec / 1000 / 60 / 60);
        //         msec -= hh * 1000 * 60 * 60;
        //         const mm = Math.floor(msec / 1000 / 60);
        //         msec -= mm * 1000 * 60;

        //         time = mm + 'min';

        //         if (hh > 0) {
        //             time = hh + 'hr ' + mm + 'min';
        //         }
        //         if (dd > 0) {
        //             time = dd + 'd ' + hh + 'hr ' + mm + 'min';
        //         }

        //         return <span>{time}</span>;
        //     },
        //     key: 'created_at',
        //     // defaultSortOrder: 'ascend',
        //     // sorter: {
        //     // 	compare: (a, b) => new Date(a.created_at) < new Date(b.created_at),
        //     // 	multiple: 1
        //     // }
        // },
        {
            title: 'Sub Total $',
            render: ({ order_total_without_tax }) => (
                <div>
                    <span>{formatter.format(order_total_without_tax)}</span>
                </div>
            )
        },
        {
            title: 'Municipal tax $',
            render: ({ product_municipal_tax }) => (
                <div>
                    <span>{formatter.format(product_municipal_tax)}</span>
                </div>
            )
        },
        {
            title: 'Processing Fee $',
            render: ({ deposit_amount,clientBankFee }) => (
                <div>
                    <span>{formatter.format(((deposit_amount * 0.03) + 0.23) + (((((deposit_amount * 0.03) + 0.23) * 0.04).toFixed(2)) * 1) + (clientBankFee + ((clientBankFee) * 0.115)).toFixed(2) * 1)}</span>
                </div>
            )
        },
        // {
        //     title: "Transaction fee",
        //     render: ({ totalTransactioFee }) => (
        //         <div>
        //             <span>{isNaN(totalTransactioFee) ? 0.0 : formatter.format(totalTransactioFee)}</span>
        //         </div>
        //     )
        // },
        {
            title: "Delivery by",
            render: ({ deliveryBy }) => (
                <div>
                    <span>{
                    //isNaN(totalDeliveryFee) ? 0.0 : formatter.format(totalDeliveryFee + delivery_fee_state_tax)
                }</span>
                </div>
            )
        },

        // {
        //     title:"Bank fee",
        //     render: ({ bankFee }) => (
        //         <div>
        //             <span>{isNaN(bankFee)?0.0:formatter.format(bankFee)}</span>
        //         </div>
        //     )
        // },
        // {
        //     title:"Total to deposit",
        //     render: ({ deposit_amount }) => (
        //         <div>
        //             <span>{formatter.format(deposit_amount)}</span>
        //         </div>
        //     )
        // },

        {
            title: "Total to deposit",
            render: ({ deposit_amount, clientBankFee }) => (
                <div>
                    <span>{

                        formatter.format(deposit_amount - (((deposit_amount * 0.03) + 0.23) + (((((deposit_amount * 0.03) + 0.23) * 0.04).toFixed(2)) * 1) + (clientBankFee + ((clientBankFee) * 0.115)).toFixed(2) * 1))
                    }</span>
                </div>
            )
        },
        // { title: 'Pharmacy', dataIndex: 'name' }
    ]
    const ProductsColumns = [
        {
            title: '',
            render: ({ img }) => (
                <div
                    style={{
                        width: 40
                    }}
                >
                    <Image src={img} />
                </div>
            ),
            key: 'img'
        },
        {
            title: 'Name',
            dataIndex: 'name',
            key: 'name'
        },
        {
            title: 'Price $',
            render: ({ price }) => (
                <div>
                    <span>{formatter.format(price)}</span>
                </div>
            ),
            key: 'price'
        },
        {
            title: 'Quantity',
            dataIndex: 'quantity',
            key: 'quantity'
        },

        {
            title: 'total $',
            render: ({ total_product }) => (
                <div>
                    <span>{formatter.format(total_product)}</span>
                </div>
            ),
            key: 'total_product'
        },
        // { title: 'Order total $', dataIndex: 'ProductOrderInformation.total_product', key: 'ProductOrderInformation.total_product' }

    ];

    const rowSelection = {
        onChange: (selectedRowKeys, selectedRows) => {
            //console.log(`selectedRowKeys: ${selectedRowKeys}`, 'selectedRows: ', selectedRows);
            setordersIdToBeAdded(selectedRowKeys)
            setSelectedOrders(selectedRows)
        },
        getCheckboxProps: (record) => ({
            disabled: record.hasBilling === true,
            // Column configuration not to be checked
            name: record.name,
        }),
    };



    const children = [];
    pharmacies.forEach((element) => {
        children.push(<Option key={element.id}>{element.name}</Option>);
    })
    const onChange = (dates, dateStrings) => {
        if (dates) {
            // console.log('From: ', dates[0], ', to: ', dates[1]);
            // console.log('From: ', dateStrings[0], ', to: ', dateStrings[1]);
            const i = new Date(dateStrings[0])
            const f = new Date(dateStrings[1])
            setinitialFilterDate(i);
            setfinalFilterDate(f);
            setFilteredOrders(orders.filter(x => {
                const date = new Date(x.created_at.slice(0, 10))
                //console.log(orders)
                return date.getTime() == i.getTime() || date.getTime() == f.getTime()

            }).reverse())
        } else {
            //console.log('Clear');
            setinitialFilterDate(dateStrings[null])
            setfinalFilterDate(dateStrings[null])
            setFilteredOrders(orders.reverse())
        }
    };
    const onSearch = (value) => {
        setFilteredOrders(orders.filter(x => {

            if (value) {
                return x.name == value

            }
            else {
                setFilteredOrders(orders)
            }

        }))
    };
    const onFinish = (values) => {
        //console.log('Success:', values);
        setbillingFormValues({ stimated_paid_date: values.stimated_paid_date, description_billing: values.description })
        createBilling()
        setshowModal(false)
        form.resetFields();
    };
    const createBilling = async () => {
        let result = SelectedOrders.reduce((accumulator, current) => accumulator + current.total_order, 0)
        // console.log(result, 'result')
        // console.log(SelectedOrders, 'status')

        const data = {
            ...billingFormValues,
            ...SelectedOrders,
            amount_orders: SelectedOrders.length,
            orders: ordersIdToBeAdded,
            billing_status_id: billingStatusPending,
            total_billing: result
        }
        // console.log(data)
        setlastBillingSubmited(await sendData(urlCreateBilling, data).then((response) => {
            if (Object.keys(response).length > 0) {
                const billingdetail = response['billing'];
            }
        }));
    }

    const menu = (
        <Menu
            items={[
                {
                    key: '1',
                    label: 'Action 1',
                },
                {
                    key: '2',
                    label: 'Action 2',
                },
            ]}
        />
    );
    const productOrderDetail = (order_id) => {
        // console.log(order_id)
        // console.log(billingOrderDetail.filter(x => x.Order.Order_id === order_id));
        const data = []
        billingOrderDetail.filter((x) => {
            if (x.Order.Order_id === order_id) {
                setproductDetail(
                    {
                        OrderId: x.Order.Order_id,
                        address_1: x.Order.address_1,
                        DriverId: x.Order.driver_id,
                        pharmacy_id: x.Order.pharmacy_id,
                        order_state_id: x.Order.order_state_id,
                        first_transaction: x.Order.first_transaction,
                        code: x.Order.code,
                        total_order: x.Order.total_order,
                        created_at: x.Order.created_at

                    }
                )
                //console.log(productDetail)
                return x.Order['OrdersDetail'].map((p) => {
                    data.push({
                        key: p.Order_detail_id,
                        img: p.ProductOrderInformation.img,
                        name: p.ProductOrderInformation.name,
                        quantity: p.quantity,
                        price: p.ProductOrderInformation.price,
                        total_product: p.total_product,
                        tax: x.taxes,
                        Order_id: x.order_id
                    })
                })
            }

        })
        //console.log(data)
        setProductsdata(data)
        let r = 0;
        setsubTotal(Productsdata.reduce((a, b) => {
            return r = b.total_product + r
        }, []))
    }
    // const expandedRowRender = () => {
    //     const columns = [
    //         {
    //             title: '',
    //             render: ({ img }) => (
    //                 <div
    //                     style={{
    //                         width: 40
    //                     }}
    //                 >
    //                     <Image src={img} />
    //                 </div>
    //             ),
    //             key: 'img'
    //         },
    //         {
    //             title: 'Name',
    //             dataIndex: 'name',
    //             key: 'name'
    //         },
    //         {
    //             title: 'Price $',
    //             dataIndex: 'price',
    //             key: 'price'
    //         },
    //         {
    //             title: 'Quantity',
    //             dataIndex: 'quantity',
    //             key: 'quantity'
    //         },

    //         {
    //             title: 'total $',
    //             dataIndex: 'total_product',
    //             key: 'total_product'
    //         },
    //         // { title: 'Order total $', dataIndex: 'ProductOrderInformation.total_product', key: 'ProductOrderInformation.total_product' }

    //     ];
    //     let data = [];
    //     billingOrderDetail.forEach((bod,index) => {

    //         // data.push(bod.Order['OrdersDetail'])
    //         let aux
    //             bod.Order['OrdersDetail'].map((x,i) => {

    //                data.push({
    //                    index:index,
    //                     key: x.Order_detail_id,
    //                     img: x.ProductOrderInformation.img,
    //                     name: x.ProductOrderInformation.name,
    //                     quantity: x.quantity,
    //                     price: x.ProductOrderInformation.price,
    //                     total_product: x.total_product
    //                 })
    //             })

    //         })
    //         for (let index = 0; index < billingOrderDetail.length; index++) {
    //             //const element = array[index];
    //             //data[index]= data.filter(x=>x.index===index)
    //             console.log(index,data.filter(x=>x.index==index))

    //         }
    //     // for (let i = 0; i < 3; ++i) {
    //     //     data.push({
    //     //         key: i,
    //     //         date: '2014-12-24 23:12:00',
    //     //         name: 'This is production name',
    //     //         upgradeNum: 'Upgraded: 56',
    //     //     });
    //     // }

    //     return <Table columns={columns} dataSource={data} pagination={false} />;
    // };
    const formatter = new Intl.NumberFormat('en-US', {
        style: 'currency',
        currency: 'USD',

        // These options are needed to round to whole numbers if that's what you want.
        //minimumFractionDigits: 0, // (this suffices for whole numbers, but will print 2500.10 as $2,500.1)
        //maximumFractionDigits: 0, // (causes 2500.99 to be printed as $2,501)
    });

    const range = (start, end) => {
        const result = [];

        for (let i = start; i < end; i++) {
            result.push(i);
        }

        return result;
    };
    const disabledDate = (current) => {
        // Can not select days before today and today
        return current && current < moment().endOf('day');
    };

    const disabledDateTime = () => ({
        disabledHours: () => range(0, 24).splice(4, 20),
        disabledMinutes: () => range(30, 60),
        disabledSeconds: () => [55, 56],
    });
    useEffect(() => {
        getOrderStates()
        getPharmacies()
        getBilling()
        getBillingstatus()
    }, [lastBillingSubmited])

    useEffect(() => {
        if ((orderStatesDelivered != 0 && orderStatesDelivered != undefined) || (orderStatesPickedUpByClient != 0 && orderStatesPickedUpByClient != undefined)) {
            getOrder()
        }
    }, [orderStatesDelivered, orderStatesPickedUpByClient, lastBillingSubmited])
    return (
        <>
            <Modal
                centered
                width={800}
                title="Order detail"
                visible={showProductModal}
                onCancel={() => { setshowProductModal(false) }}
                footer={(null)}
                closable={true}
            >
                {/* <h2>Order: #{selectedOrder.code}</h2> */}
                <Descriptions
                    title="Order detail"
                    bordered
                    //size={'small'}
                    extra={
                        <Tag color={productDetail.order_state_id == 1 ? 'volcano' : 'green'}>
                            {(productDetail.order_state_id == 1 && 'Pending') ||
                                (productDetail.order_state_id == 2 && 'Processing') ||
                                (productDetail.order_state_id == 3 && 'Ready for pick up by delivery') ||
                                (productDetail.order_state_id == 4 && 'On the way') ||
                                (productDetail.order_state_id == 5 && 'Delivered') ||
                                (productDetail.order_state_id == 6 && 'Rejected') ||
                                (productDetail.order_state_id == 7 && 'Ready to be picked up by client')}
                        </Tag>}
                >
                    <Descriptions.Item label="Order code">{productDetail.code}</Descriptions.Item>
                    <Descriptions.Item label="Pharmacy">{productDetail.pharmacy_id}</Descriptions.Item>
                    <Descriptions.Item label="First transaction">{productDetail.first_transaction ? 'Yes' : 'Not'}</Descriptions.Item>
                    <Descriptions.Item label="Driver">{productDetail.DriverId ? productDetail.DriverId : 'N/A'}</Descriptions.Item>
                    {/* <Descriptions.Item label="Status">{productDetail.order_state_id}</Descriptions.Item> */}
                    <Descriptions.Item label="Create at">{productDetail.created_at}</Descriptions.Item>
                </Descriptions>
                <Divider />
                {/* {Object.keys(products).length > 0 && ( */}
                <>
                    <Table
                        columns={ProductsColumns}
                        dataSource={Productsdata}
                        scroll={{ x: 800 }}
                        footer={() => {
                            return (
                                <Row gutter={24} style={{ padding: '10px' }}>

                                    <Col span={21}>
                                        <h4>Sub total</h4>
                                    </Col>
                                    <Col span={3} style={{ textAlign: 'right' }}>
                                        <h4>{formatter.format(subTotal)}</h4>
                                    </Col>

                                    <Col span={21}>
                                        <h4>State TAX</h4>
                                    </Col>
                                    <Col span={3} style={{ textAlign: 'right' }}>
                                        <h4>{formatter.format(subTotal * 0.105)}</h4>
                                    </Col>
                                    <Col span={21}>
                                        <h4>Municipal TAX</h4>
                                    </Col>
                                    <Col span={3} style={{ textAlign: 'right' }}>
                                        <h4>{formatter.format(subTotal * 0.01)}</h4>
                                    </Col>
                                    <Col span={21}>
                                        <h4>Transaction fee</h4>
                                    </Col>
                                    <Col span={3} style={{ textAlign: 'right' }}>
                                        <h4>{formatter.format(1)}</h4>
                                    </Col>
                                    <Col span={21} >
                                        <h4>Municipal fee</h4>
                                    </Col>
                                    <Col span={3} style={{ textAlign: 'right' }}>
                                        <h4>{formatter.format(6)}</h4>
                                    </Col>
                                    <Divider />
                                    <Col span={21}>
                                        <h4>Total</h4>
                                    </Col>

                                    <Col span={3} style={{ textAlign: 'right' }}>
                                        <h4>{formatter.format(productDetail.total_order)}</h4>
                                    </Col>

                                </Row>
                            )
                        }
                        }
                        //rowKey={(item) => item.product_pharmacy_id}
                        pagination={false}
                    />
                </>
                {/* )} */}

            </Modal>
            <Modal
                centered
                width={800}
                title="Payouts detail"
                visible={showDetailModal}
                onCancel={() => { setshowDetailModal(false) }}
                footer={null}
                closable={true}
            >
                <Descriptions colon={false} title="Payouts"
                // extra={<ExportExcel data={filterBilling} name="Payouts detail"></ExportExcel>} 
                >
                    <Descriptions.Item span={2}><h3 >#{billingDetail.code}</h3></Descriptions.Item>
                    <Descriptions.Item label="Status">
                        <Tag color={billingDetail.billing_status_id == 1 ? 'volcano' : 'green'}>
                            {(billingDetail.billing_status_id == 1 && 'Pending') ||
                                (billingDetail.billing_status_id == 2 && 'Paid') ||
                                (billingDetail.billing_status_id == 3 && 'Ready for pick up by delivery') ||
                                (billingDetail.billing_status_id == 4 && 'On the way') ||
                                (billingDetail.billing_status_id == 5 && 'Delivered') ||
                                (billingDetail.billing_status_id == 6 && 'Rejected') ||
                                (billingDetail.billing_status_id == 7 && 'Ready to be picked up by client')}
                        </Tag>
                    </Descriptions.Item>
                    <Descriptions.Item label="Date" >{new Date(billingDetail.created_at).toLocaleDateString("en-US")}</Descriptions.Item>
                </Descriptions>

                <Tabs defaultActiveKey="1" type="card" size={'large'}>
                    <TabPane tab="Orders" key="1">
                        <Table
                            dataSource={billingDetailOrder}
                            scroll={{ x: 800 }}
                            //expandable={{
                            //     expandedRowRender,
                            // }}
                            onRow={(record) => {
                                return {
                                    onClick: () => {
                                        productOrderDetail(record.id)
                                        setshowProductModal(true)
                                    }
                                };
                            }}
                            rowKey={(Item) => Item.id} columns={OrderColumns} />
                    </TabPane>
                </Tabs>
            </Modal>
            <Modal
                centered
                width={800}
                title="Create payout"
                visible={showModal}
                onCancel={() => { setshowModal(false) }}
                footer={null}
                closable={true}
            >
                <Form
                    layout={"vertical"}
                    form={form}
                    onFinish={onFinish}

                >
                    <Form.Item label="Stimated paid date" name={"stimated_paid_date"}
                        rules={[
                            {
                                required: true,
                                message: 'Please input a date!',
                            },
                        ]}>
                        <DatePicker
                            disabledDate={disabledDate}
                            // disabledTime={disabledDateTime}
                            style={{ width: '100%' }}
                            showTime={{
                                defaultValue: moment('00:00:00', 'HH:mm:ss'),
                            }}
                        />
                    </Form.Item >
                    <Form.Item label="Description" name={'description_billing'}>
                        <Input.TextArea />
                    </Form.Item>
                    <Form.Item >
                        <Button
                            htmlType="submit"
                            style={{
                                height: 40,
                                color: '#fff',
                                borderRadius: 4,
                                fontSize: 16,
                                width: '100%',
                                backgroundColor: '#128780',
                                position: 'relative',
                                // float: 'right',


                                marginRight: 0
                            }}
                        >Submit</Button>
                    </Form.Item>
                    <Form.Item>
                        <Row gutter={24}>
                            <Col span={24}>
                                <Table
                                    dataSource={SelectedOrders} rowKey={(Item) => Item.id} scroll={{ x: 800 }} columns={columns} />
                            </Col>
                        </Row>

                    </Form.Item>
                </Form>

            </Modal>
            <Tabs defaultActiveKey="1" size={'small'} type="card">
                <TabPane tab="Order" key="1">

                    <Row gutter={24}>
                        {/* <Col span={14}>
                            <Select
                                allowClear
                                style={{
                                    width: '100%',
                                }}
                                placeholder="Please select"
                                showSearch
                                onSearch={onSearch}
                                filterOption={(input, option) => option.children.toLowerCase().includes(input.toLowerCase())}

                            >
                                {children}
                            </Select>
                        </Col> */}
                        <Col span={6}>
                            <RangePicker
                                placement='bottonRight'
                                onChange={onChange}
                            />
                        </Col>
                        <Col span={4}>
                            {/* <Button
                                onClick={() => { setshowModal(true) }}
                                type='primary'

                                style={{
                                    height: 40,
                                    color: '#fff',
                                    borderRadius: 4,
                                    fontSize: 16,
                                    width: 150,
                                    backgroundColor: '#128780',
                                    position: 'relative',
                                    float: 'right',


                                    marginRight: 0
                                }}
                                disabled={ordersIdToBeAdded.length == 0}
                            >Create billing</Button> */}
                        </Col>

                    </Row>
                    <br />
                    <Row gutter={24}>
                        <Col span={24}>
                            <Table
                                // rowSelection={{
                                //     type: selectionType,
                                //     ...rowSelection,
                                // }}
                                dataSource={filteredOrders} rowKey={(Item) => Item.id} scroll={{ x: 1300 }} columns={columns} />;
                        </Col>
                    </Row>

                </TabPane>
                <TabPane tab="Payouts" key="2">

                    <Row gutter={24}>
                        {/* <Col span={16}>
                            <Select
                                allowClear
                                style={{
                                    width: '100%',
                                }}
                                placeholder="Please select"
                            >
                                {children}
                            </Select>
                        </Col> */}
                        <Col span={8}>
                            <RangePicker
                                placement='bottonRight'
                                onChange={onChange}
                            />
                        </Col>

                    </Row>
                    <br />
                    <Row gutter={24}>

                        <Col span={24}>
                            <Table
                                dataSource={filterBilling} rowKey={(Item) => Item.id} scroll={{ x: 1300 }} columns={billingColumn}
                                onRow={(record) => {
                                    return {
                                        onClick: () => {
                                            setshowDetailModal(true)
                                            setbillingDetail(record)
                                            getBillingDetailByPharmacy(record.id)
                                            //console.log(billingDetail)

                                        }
                                    }
                                }}
                            />
                        </Col>
                    </Row>
                </TabPane>
            </Tabs>

        </>
    )
}
export default Billing